import React from 'react'

// Load components
import { Text, Box } from '@chakra-ui/react'
import Icon from '../UI/Icon/Icon'

const ErrorBoundary = ({ componentName = 'page' }) => {
    return (
        <Box
            border="1px"
            borderColor="error.900"
            height="100%"
            width="100%"
            margin="0 auto"
            position="relative"
            backgroundColor="rgb(224, 23, 27, 0.2)"
            textAlign="center"
            padding={4}
            color="tertiary.900"
        >
            <Icon icon="warningTriangle" />
            <Text textStyle="p" fontWeight="bold">
                Unable to load {componentName}
            </Text>
        </Box>
    )
}

export default ErrorBoundary
